export default __webpack_public_path__ + "static/media/kg.3f94a4cb.jpg";